import React, { useEffect, useMemo } from "react";
import "./SimplePage.scss";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import parse from "html-react-parser";
import Adsense from "../../Reusable/Adsense/Adsense.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import config from "config";

const SimplePage = ({ children }) => {
  const {
    getPageText,
    replaceKeywordsInText,
    getPath,
    getCurrentPage,
    getSupportText,
  } = useContent();
  const { desktopCondition } = useMediaQueries();

  useMemo(() => {
    if (getCurrentPage() === "careers") {
      window.location.href = config.baseurl + getPath();
    }
  }, [getCurrentPage()]);

  useEffect(() => {
    if (
      getCurrentPage() === "privacy-policy" &&
      (getPath() === "/en/" || getPath() === "/he/")
    ) {
      document.getElementById("btnDeleteCookies").onclick =
        DeleteCookiesFunction;
    }
  }, []);
  const DeleteCookiesFunction = () => {
    //  $('#success-message').css('display', "inline-block");
    //$('#btnDeleteCookies').css('display', "none");
    document.cookie.split(";").forEach(function (cookie) {
      deleteCookie(cookie);
    });
    document.getElementById("success-message").style.display = "inline-block";
    document.getElementById("btnDeleteCookies").style.display = "none";
  };

  function deleteCookie(name) {
    setCookie(name, "", null, null, null, 1);
  }

  function setCookie(
    key,
    value,
    expireDays,
    expireHours,
    expireMinutes,
    expireSeconds
  ) {
    var expireDate = new Date();
    if (expireDays) {
      expireDate.setDate(expireDate.getDate() + expireDays);
    }
    if (expireHours) {
      expireDate.setHours(expireDate.getHours() + expireHours);
    }
    if (expireMinutes) {
      expireDate.setMinutes(expireDate.getMinutes() + expireMinutes);
    }
    if (expireSeconds) {
      expireDate.setSeconds(expireDate.getSeconds() + expireSeconds);
    }
    document.cookie =
      key +
      "=" +
      escape(value) +
      ";domain=" +
      window.location.hostname +
      ";path=/" +
      ";expires=" +
      expireDate.toUTCString();
    document.cookie =
      key +
      "=" +
      escape(value) +
      ";domain=" +
      ".jumbomail.me" +
      ";path=/" +
      ";expires=" +
      expireDate.toUTCString();
    document.cookie =
      key +
      "=" +
      escape(value) +
      ";domain=" +
      "www.jumbomail.me" +
      ";path=/" +
      ";expires=" +
      expireDate.toUTCString();
  }
  return (
    <div
      className={`page-text-warpper ${
        getPageText().Page_Culture
          ? getPageText().Page_Culture === "en-US"
            ? "simple-pages-ltr"
            : ""
          : ""
      }`}
    >
      <div
        className={
          /*Check if the page is not support pages*/ getCurrentPage() ===
            "terms" ||
          getCurrentPage() === "jumbo-pay-terms" ||
          getCurrentPage() === "privacy-policy" ||
          getCurrentPage() === "careers" ||
          getCurrentPage() === "accessibility" ||
          getCurrentPage() === "about"
            ? "text-page-container"
            : getCurrentPage() === "user-blocked"
            ? "text-page-container block-container-page"
            : getSupportText().questionsList.length > 0
            ? "text-page-container support-page support-categories-page"
            : "text-page-container support-page"
        }
      >
        {getCurrentPage() === "terms" ||
        getCurrentPage() === "jumbo-pay-terms" ||
        getCurrentPage() === "privacy-policy" ||
        getCurrentPage() === "careers" ||
        getCurrentPage() === "accessibility" ||
        getCurrentPage() === "user-blocked" ||
        (getCurrentPage() === "about" && getPageText().Display_title) ? (
          <div className="page-text-title-container">
            {getPageText().Title_Tooltip === "Our Story" ? (
              <h2>
                {getPageText().Display_title
                  ? parse(getPageText().Display_title)
                  : null}
              </h2>
            ) : (
              <h1>
                {getPageText().Display_title
                  ? parse(getPageText().Display_title)
                  : null}
              </h1>
            )}
            <div className="title-divider"></div>{" "}
          </div>
        ) : null}

        {getPageText().ads ? (
          <Adsense.Google
            client="ca-pub-6726288251360970"
            slot={desktopCondition() ? "9918388683" : "0"}
            layout="in-article"
            format="fluid"
          />
        ) : null}

        <div
          className={`text-page-content ${children ? "no-background" : null}`}
        >
          {children ? (
            children
          ) : (
            <div className="text-page-paragraph">
              {getPageText().TextBox
                ? parse(replaceKeywordsInText(getPageText().TextBox))
                : null}
              {getPageText().TextBox2
                ? parse(replaceKeywordsInText(getPageText().TextBox2))
                : null}
              {getPageText().TextBox3
                ? parse(replaceKeywordsInText(getPageText().TextBox3))
                : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimplePage;
